import { render, staticRenderFns } from "./EntityFormPage.vue?vue&type=template&id=cbcbb7bc&scoped=true"
import script from "./EntityFormPage.vue?vue&type=script&lang=js"
export * from "./EntityFormPage.vue?vue&type=script&lang=js"
import style0 from "./EntityFormPage.vue?vue&type=style&index=0&id=cbcbb7bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbcbb7bc",
  null
  
)

export default component.exports